import { defineStore } from 'pinia'
import { AsyncComponentLoader } from 'vue'
import type { Snackbar, DynamicDialogData } from '@/types/widget'

export const useWidgetStore = defineStore('widget', {
  state: () => ({
    snackbarQueue: [] as Snackbar[],
    activeDialog: null as DynamicDialogData | null,
    dialogResolve: null as ((value?: any) => void) | null
  }),
  actions: {
    createSnackbar(snackbarProperties: Snackbar) {
      const id = Date.now()
      this.snackbarQueue.push({
        ...snackbarProperties,
        id
      })
    },
    removeSnackbar(snackbar: Snackbar) {
      this.snackbarQueue = this.snackbarQueue.filter(
        (item) => item.id !== snackbar.id
      )
    },
    openDialog<T = any>(
      loader: AsyncComponentLoader,
      props?: Record<string, any>,
      events?: Record<string, (...args: any[]) => any>
    ): Promise<T | undefined> {
      return new Promise((resolve) => {
        this.dialogResolve = resolve
        this.activeDialog = {
          loader,
          props,
          events,
          positiveAction: (data: T) => resolve(data)
        }
      })
    },
    closeDialog() {
      if (this.dialogResolve) {
        this.dialogResolve(undefined)
        this.dialogResolve = null
      }
      this.activeDialog = null
    }
  }
})
